import React, { useState } from 'react';
import { auth } from '../utils/auth';
import { api } from '../utils/api';

interface SigninFormProps {
  onSignin: (user: any) => void;
}

const SigninForm: React.FC<SigninFormProps> = ({ onSignin }) => {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const token = await api.signin(formData);
      if (token) {
        auth.setToken(token);
        onSignin({
          email: formData.email,
          token,
        });
      } else {
        setError('Signin failed');
      }
    } catch (err) {
      setError('Failed to connect to server');
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div>
        <input
          type="email"
          required
          value={formData.email}
          onChange={(e) => setFormData({ ...formData, email: e.target.value })}
          className="w-full px-3 py-2 border border-neutral-300 focus:border-neutral-500 focus:outline-none font-mono text-sm"
          placeholder="email"
        />
      </div>

      <div>
        <input
          type="password"
          required
          value={formData.password}
          onChange={(e) => setFormData({ ...formData, password: e.target.value })}
          className="w-full px-3 py-2 border border-neutral-300 focus:border-neutral-500 focus:outline-none font-mono text-sm"
          placeholder="password"
        />
      </div>

      {error && (
        <div className="p-2 border border-neutral-300 bg-neutral-50 text-xs font-mono text-neutral-700">
          {error}
        </div>
      )}

      <button
        type="submit"
        disabled={loading}
        className="w-full py-2 border border-neutral-900 bg-neutral-900 text-white font-mono text-sm hover:bg-neutral-800 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
      >
        {loading ? 'loading...' : 'sign in'}
      </button>
    </form>
  );
};

export default SigninForm;

